import { __decorate } from "tslib";
import { BasePlugin, Plugin } from "@fastoche/core";
import { GlobalApplicationContext } from "../application/GlobalApplicationContext";
let MvcVuePlugin = class MvcVuePlugin extends BasePlugin {
    install(ctx, config) {
        this.rootComponentConstructor = config.rootComponent;
    }
    start(ctx) {
        const ctor = this.rootComponentConstructor;
        const options = ctor.options;
        const pageComponents = options.components || {};
        document
            .querySelectorAll("[is]")
            .forEach(isolate => isolate.setAttribute("v-pre", ""));
        this.rootComponentInstance = new ctor().$mount("#app");
        GlobalApplicationContext.default.vue = this.rootComponentInstance;
        window.Leavy = window.Leavy || {};
        window.Leavy.page = this.rootComponentInstance;
        const isolates = document.querySelectorAll("[is]");
        for (const isolate of isolates) {
            const componentName = isolate.getAttribute("is") || "";
            const componentConstructor = pageComponents[componentName];
            if (!componentConstructor) {
                throw new Error(`Component ${componentName} is not registered on the page.`);
            }
            isolate.removeAttribute("is");
            new componentConstructor({ parent: this.rootComponentInstance }).$mount(isolate);
        }
    }
};
MvcVuePlugin = __decorate([
    Plugin()
], MvcVuePlugin);
export { MvcVuePlugin };
//# sourceMappingURL=MvcVuePlugin.js.map